<template>
  <v-card>
    <v-card-title>
      Locations
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="ml-3 mr-3 my-2" v-on="on">
            <v-icon left>mdi-office-building</v-icon>Add Location
          </v-btn>
        </template>

        <v-form ref="form" lazy-validation>
          <v-card>
            <v-card-title>{{ formTitle }}</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="9">
                    <v-text-field
                      v-model="editedItem.description"
                      label="Description"
                      :counter="200"
                      :rules="descriptionRules"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox v-model="editedItem.isActive" label="Is active?"></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="close">Cancel</v-btn>
              <v-btn color="primary" @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <ReturnHomeBtn />
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="8" md="5">
            <v-radio-group v-model="filterOption" row>
              <v-radio label="All" value="all"></v-radio>
              <v-radio label="Active only" value="active"></v-radio>
              <v-radio label="Inactive only" value="inactive"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" sm="4" md="7">
            <v-text-field
              v-model="search"
              append-outer-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-data-table
      :loading="!locations"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="locationsFiltered"
      :search="search"
    >
      <template v-slot:item.id="{ item }">
        <v-chip label outlined :color="item.color" class="font-weight-bold">{{ item.id }}</v-chip>
      </template>

      <template v-slot:item.isActive="{ item }">
        <v-simple-checkbox v-model="item.isActive" disabled></v-simple-checkbox>
      </template>
      <template v-slot:item.isEvaluator="{ item }">
        <v-simple-checkbox v-model="item.isEvaluator" disabled></v-simple-checkbox>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-layout :justify-end="true">
          <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
          <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        </v-layout>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessageMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";

export default {
  name: "Locations",
  mixins: [errorMessageMixin],
  components: { ReturnHomeBtn },
  async created() {
    await this.loadLocations();
  },
  computed: {
    ...mapState(["locations"]),
    locationsFiltered: function() {
      if (this.filterOption === "active") {
        return this.locations.filter(x => x.isActive);
      }
      if (this.filterOption === "inactive") {
        return this.locations.filter(x => !x.isActive);
      }
      return this.locations;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add Location" : "Edit Location";
    }
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Id",
          value: "id",
          align: "start"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Is Active",
          value: "isActive"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      filterOption: "all",
      dialog: false,
      editedIndex: -1,
      editedItem: {},
      descriptionRules: [
        v => !!v || "Description is required.",
        v =>
          (v && v.length <= 200) ||
          "Description name must be less than 200 characters"
      ]
    };
  },
  methods: {
    ...mapActions([
      "getLocationsAction",
      "updateLocationAction",
      "addLocationAction",
      "deleteLocationAction"
    ]),
    async loadLocations() {
      try {
        await this.getLocationsAction();
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },
    async save() {
      console.log("updte with this.editedItem", this.editedItem);
      if (!this.$refs.form.validate()) {
        return;
      }
      console.log("im valid");
      if (this.editedIndex > -1) {
        try {
          const model = { ...this.editedItem };
          await this.updateLocationAction({
            model: model,
            token: this.$store.state.token
          });
          this.close();
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
      } else {
        try {
          const model = { ...this.editedItem };

          await this.addLocationAction({
            model: model,
            token: this.$store.state.token
          });
          this.close();
        } catch (err) {
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
      }
    },
    async deleteItem(item) {
      console.log("im in delete", item);
      if (confirm("Remove Location " + item.description + "?")) {
        this.$store.state.fullScreenLoading = true;
        const deleteLocationModel = {
          locationId: item.id
        };
        try {
          await this.deleteLocationAction({
            model: deleteLocationModel,
            token: this.$store.state.token
          });
          // write a message
          console.log("delete done");
        } catch (err) {
          console.log("im in error");
          this.$store.state.error = this.errorMessage(err);
          this.$store.state.snackbar = true;
          console.log(err);
        }
        this.$store.state.fullScreenLoading = false;
      }
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedIndex = this.locations.indexOf(item);
      console.log("this.editedItem", this.editedItem);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      }, 300);
    },
  }
};
</script>